import styled from 'styled-components';

// Import optimized images
import img400WebP from '../assets/consulting-image-400w.webp';
import img400Jpeg from '../assets/consulting-image-400w.jpeg';
import img800WebP from '../assets/consulting-image-800w.webp';
import img800Jpeg from '../assets/consulting-image-800w.jpeg';
import img1200WebP from '../assets/consulting-image-1200w.webp';
import img1200Jpeg from '../assets/consulting-image-1200w.jpeg';
import img1920WebP from '../assets/consulting-image-1920w.webp';
import img1920Jpeg from '../assets/consulting-image-1920w.jpeg';

interface ResponsiveImageProps {
  alt: string;
  className?: string;
  priority?: boolean; // For above-the-fold images
}

const StyledPicture = styled.picture`
  display: block;
  width: 100%;
  height: 100%;
`;

const StyledImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;

/**
 * Responsive consulting image component with WebP support and multiple sizes
 * Provides optimal loading performance by serving appropriate image sizes
 */
export function ResponsiveConsultingImage({
  alt,
  className,
  priority = false
}: ResponsiveImageProps) {
  return (
    <StyledPicture className={className}>
      {/* WebP sources for modern browsers */}
      <source
        srcSet={`
          ${img400WebP} 400w,
          ${img800WebP} 800w,
          ${img1200WebP} 1200w,
          ${img1920WebP} 1920w
        `}
        sizes="(max-width: 480px) 400px, (max-width: 768px) 800px, (max-width: 1200px) 1200px, 1920px"
        type="image/webp"
      />
      {/* JPEG fallback for older browsers */}
      <source
        srcSet={`
          ${img400Jpeg} 400w,
          ${img800Jpeg} 800w,
          ${img1200Jpeg} 1200w,
          ${img1920Jpeg} 1920w
        `}
        sizes="(max-width: 480px) 400px, (max-width: 768px) 800px, (max-width: 1200px) 1200px, 1920px"
        type="image/jpeg"
      />
      {/* Default fallback image */}
      <StyledImg
        src={img1200Jpeg}
        alt={alt}
        loading={priority ? 'eager' : 'lazy'}
        decoding="async"
      />
    </StyledPicture>
  );
}
